import React, { useState, useEffect } from "react";
import './ForgotPassword.css'
import {
    PasswordResetRequest
} from './Requests';
import {PulseLoader } from "react-spinners";

  const RequestForgotPassword = () => {
    const [email, setEmail] = useState()
    const [resetButton, setResetButton] = useState(true)
    const [passwordResetState, setPasswordResetState] = useState("enter email")
    const [isLoading, setIsLoading] = useState(false)

    function resetLinkClicked()
    {
        if(email === undefined || email === null || email === "")
        {
        }
        else
        {
            setIsLoading(true)
            PasswordResetRequest(email).then((res) => {
            if (res.status === 200)
            {
                setPasswordResetState(200)
                setIsLoading(false)
            }
        }).catch((error) => {
            if(error.response.status === 400)
            {
                setPasswordResetState(400)
                setIsLoading(false)
            }
        })
        }
    }

    function EmailHandler(email)
    {
        if(email === undefined || email === null || email === "")
        {
            setResetButton(true)
        }
        else
        {
            setEmail(email)
            setResetButton(false)
        }
    }
 
    return (
        <div className="request-forgot-password-container">
            <div className="request-forgot-password-card">
            <PulseLoader 
                color={'#333'}
                loading={isLoading}
                size={25}
                aria-label="Loading Spinner"
                data-testid="loader"
            />
            {passwordResetState == "enter email" && !isLoading ?
            <div>
                <h1>Forgot Password</h1>
                <div style={{width:"80%", marginLeft:"auto", marginRight:"auto"}}>
                    <label htmlFor="">Email Address</label>
                </div>
                <input onChange={(e) => {EmailHandler(e.target.value.toLowerCase())}} style={{width:"80%"}} type="email" id="" placeholder="email address" />
                <button disabled={resetButton} onClick={(e) => {resetLinkClicked()}} className={!resetButton ? "reset-button": "disabled-reset-button"}>Send Password Reset Link</button>
            </div>
            :
            passwordResetState === 400 && !isLoading
            ?
            <div>
                <h1>Oh No!</h1>
                <p>It looks like the email you entered is invalid</p>
            </div>
            :
            passwordResetState === 200 && !isLoading
            ?
            <div>
                <h1>Email Sent</h1>
                <p>If this email is linked with an account, an email will be sent to your inbox</p>
            </div>
            :
            <div>
            </div>
  }

            </div>
        </div>
            

    );
  };
  
  export default RequestForgotPassword;